<template>
  <div style="display: flex;justify-content: space-between">
    <el-checkbox v-model="job.express" style="line-height: 28px;margin-right: 2px" :disabled="disabled" @change="expressChangeHandler">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
    <el-input v-if="job.express" v-model="job.mbl" :disabled="disabled" @change="onChange('mbl')" />
    <mawb-no-input v-show="!job.express" v-model="job.mbl" :editable="disabled || isEditablemawbNoInput" @change="onChange('mbl')" />
  </div>
</template>

<script>
import mawbNoInput from '@/components/Cargo/Job/mawbNoInput'

export default {
  name: 'AeBasicMbl',
  components: { mawbNoInput },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    isEditablemawbNoInput: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    expressChangeHandler() {
      const data = [{ key: 'express', value: this.job.express }]
      if (!this.job.express) {
        this.job.mbl = ''
        data.push({ key: 'mbl', value: '' })
      }
      this.$emit('childrenChange', data)
    }
  }
}
</script>
